import { Cloud, Home, Notifications, Photo, RequestPage, VerifiedUser, AssignmentTurnedIn } from '@mui/icons-material';
import { Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Paper } from '@mui/material';
import { useCallback } from 'react';

export interface MenuProps {
  onClickItem: (key: string) => void;
}

export const Menu = ({ onClickItem }: MenuProps) => {
  const onClickHandler = useCallback(
    (key: string) => {
      return () => {
        onClickItem?.(key);
      };
    },
    [onClickItem],
  );

  return (
    <Paper>
      <MenuList>
        <MenuItem onClick={onClickHandler('/')}>
          <ListItemIcon>
            <Home fontSize="small" />
          </ListItemIcon>
          <ListItemText>Início</ListItemText>
        </MenuItem>
        <MenuItem onClick={onClickHandler('profile')}>
          <ListItemIcon>
            <VerifiedUser fontSize="small" />
          </ListItemIcon>
          <ListItemText>Perfil do usuário</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={onClickHandler('sample-request')}>
          <ListItemIcon>
            <RequestPage fontSize="small" />
          </ListItemIcon>
          <ListItemText>Requisição</ListItemText>
        </MenuItem>
        <MenuItem onClick={onClickHandler('sample-auth-request')}>
          <ListItemIcon>
            <Cloud fontSize="small" />
          </ListItemIcon>
          <ListItemText>Requisição autenticada</ListItemText>
        </MenuItem>
        <MenuItem onClick={onClickHandler('images')}>
          <ListItemIcon>
            <Photo fontSize="small" />
          </ListItemIcon>
          <ListItemText>Imagens</ListItemText>
        </MenuItem>
        <MenuItem onClick={onClickHandler('notificatiion')}>
          <ListItemIcon>
            <Notifications fontSize="small" />
          </ListItemIcon>
          <ListItemText>Notificações</ListItemText>
        </MenuItem>
        <MenuItem onClick={onClickHandler('document-signer')}>
          <ListItemIcon>
            <AssignmentTurnedIn fontSize="small" />
          </ListItemIcon>
          <ListItemText>Assinador</ListItemText>
        </MenuItem>
      </MenuList>
    </Paper>
  );
};
